import { useCallback } from "react";
import { useQueryClient } from '@tanstack/react-query';
import { onAVStarted, onAVStopped, useAuthStateStore, } from "@annunciate/core";
import { getProgressTime } from "../../../utils/progress";
const { getUUID } = useAuthStateStore.getState();
export const usePlayPauseHelpers = () => {
    const client = useQueryClient();
    const onPause = useCallback((contentId) => {
        let progress = client.getQueryData([`progress`, { contentId, uuid: getUUID() }]);
        const position = progress ? getProgressTime(progress) : 0;
        onAVStopped(contentId, position);
    }, [client]);
    const onUnpause = useCallback((contentId, isResume = false) => {
        let progress = client.getQueryData([`progress`, { contentId, uuid: getUUID() }]);
        const position = progress ? getProgressTime(progress) : 0;
        onAVStarted(contentId, position, isResume);
        return position;
    }, [client]);
    return {
        onPause,
        onUnpause,
    };
};
//# sourceMappingURL=usePlayPauseHelpers.js.map